import { MenuItem, Select, type SelectChangeEvent } from '@mui/material'
import {
  ResponseEmployeeSubTypeEnum,
  type TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import { FormatLabel } from '../../dumb'

type Props = {
  node: TemplateNodeSchema
  updateTemplateNode: (nodeId: number, changeNode: TemplateNodeSchema) => void
}

export const EmployeeInputMethodSelect = ({
  node,
  updateTemplateNode,
}: Props) => {
  return (
    <>
      <FormatLabel>入力方法:</FormatLabel>
      <Select
        defaultValue={node.question?.responseEmployees?.[0]?.subType}
        size="small"
        sx={{ width: 240, mr: 1 }}
        onChange={(e: SelectChangeEvent<number>) => {
          updateTemplateNode(node.id, {
            ...node,
            question: {
              ...node.question,
              responseEmployees: [
                {
                  templateQuestionId: node.question?.id,
                  subType: e.target.value as number,
                  isMultiple: node.question?.responseEmployees?.[0]?.isMultiple,
                },
              ],
            },
          })
        }}
      >
        <MenuItem value={ResponseEmployeeSubTypeEnum.NAME}>
          従業員名による入力
        </MenuItem>
        <MenuItem value={ResponseEmployeeSubTypeEnum.CODE}>
          従業員管理番号による入力
        </MenuItem>
      </Select>
    </>
  )
}
